import React from "react";

const eventContext = React.createContext(null);

export default eventContext;
